import { tns } from 'tiny-slider/src/tiny-slider';

const buildSliders = () => {
  // Hero Slider - #M01.
  const sliders = document.querySelectorAll('.slider');
  for (let i = 0; i < sliders.length; i++) {
    const element = sliders[i];
    tns({
      container: element,
      mode: 'fade',
      autoplay: true,
      items: 1,
      slideBy: 1,
      speed: 2000,
      nav: false,
      controls: false,
      autoplayButtonOutput: false,
    });
  }

  function tabClickEvent(element, buttons, ourItems, tabWrapper, images, parent) {
    element.addEventListener('click', () => {
      const dataID = element.getAttribute('data-id');
      const activeItem = tabWrapper.querySelector(`[data-item="${dataID}"]`);
      const activeImage = parent.querySelector(`[data-image="${dataID}"]`);

      if (element.classList.contains('tab-button--image')) {
        images.forEach(el => {
          el.classList.remove('active');
        });
        activeImage.classList.add('active');
      }

      // Remove 'active' state from our elements.
      ourItems.forEach(el => { el.classList.remove('active'); });
      buttons.forEach(el => { el.classList.remove('active'); });

      // Add 'active' state to newly selected element.
      element.classList.add('active');
      activeItem.classList.add('active');

      // NOTE: removed for Charlie. He prefered the div to be a fixed height.
      // tabWrapper.style.setProperty('--max-height', `${activeItem.clientHeight}px`);
    });
  }

  // Tab functionality.
  const tabbed = document.querySelectorAll('.tabbed');

  for (let i = 0; i < tabbed.length; i++) {
    let maxHeight = 0;
    const parent = tabbed[i];
    const tabWrapper = parent.querySelector('.tab-wrapper');
    const ourItems = parent.querySelectorAll('.tab-item');
    const buttons = parent.querySelectorAll('.tab-button');
    const images = parent.querySelectorAll('.slideshow-image');

    // NOTE: removed for Charlie. He prefered the div to be a fixed height.
    // const firstEl = parent.querySelector('.tab-item.active');
    // const elHeight = firsEl
    // if (maxHeight >= firstEl.clientHeight) {
    //   maxHeight = firstEl.clientHeight;
    //   // Set initial height of our wrapper.
    //   tabWrapper.style.setProperty('--max-height', `${maxHeight}px`);
    // }

    for (let index = 0; index < ourItems.length; index++) {
      const element = ourItems[index];
      const elHeight = element.clientHeight;
      if (maxHeight < elHeight) {
        maxHeight = elHeight;
        tabWrapper.style.setProperty('--max-height', `${maxHeight}px`);
      }
    }

    // Lets check our child elements! Add Our Event listeners.
    for (let index = 0; index < buttons.length; index++) {
      const element = buttons[index];
      tabClickEvent(element, buttons, ourItems, tabWrapper, images, parent);
    }
  }
};

// Init our functions on page load.
document.addEventListener('DOMContentLoaded', () => {
  buildSliders();
});

export default buildSliders;



// WEBPACK FOOTER //
// ./assets/js/src/sliders.js